module.exports = "/dashboard/manage/users/edit-wages-07699a.html";